// (function () {
//   var ns = (window.SpareParts = window.SpareParts || {});
//   ns.helpers = ns.helpers || {};

//   function detailContainer(instance) {
//     return instance.root.querySelector('.spare-parts__detail');
//   }

//   function renderLoading(instance) {
//     detailContainer(instance).innerHTML = '<div class="spare-parts__loading"></div>';
//   }

//   function renderMessage(instance, message) {
//     detailContainer(instance).innerHTML =
//       '<div class="spare-parts__message">' +
//       ns.helpers.escapeHtml(message) +
//       '</div>';
//   }

//   function stockMarkup(part) {
//     if (part.madison_sku && part.stock != null && part.stock !== '') {
//       if (Number(part.stock) > 0) {
//         return '<span class="spare-parts__stock spare-parts__stock--in">In stock</span>';
//       }

//       return '<span class="spare-parts__stock spare-parts__stock--out">Out of stock</span>';
//     }

//     return '<span class="spare-parts__stock spare-parts__stock--none">' +
//       (part.obsolete ? 'Obsolete' : 'Not stocked') +
//       '</span>';
//   }

//   function orderMarkup(part) {
//     if (part.madison_sku && part.url) {
//       var href = ns.helpers.productUrl(part.url);
//       return '<a class="spare-parts__buy" href="' + ns.helpers.escapeHtml(href) + '">' +
//         (Number(part.stock) > 0 ? 'Buy' : 'Info') +
//         '</a>';
//     }

//     if (part.obsolete) {
//       return '';
//     }

//     return '<a href="/pages/contact-us">Contact Us</a>';
//   }

//   function rowMarkup(partId, part) {
//     var sku = part.madison_sku || part.global_sku_code || '';
//     var skuLabel = part.madison_sku && part.url
//       ? '<a class="spare-parts__sku" href="' + ns.helpers.escapeHtml(ns.helpers.productUrl(part.url)) + '">' + ns.helpers.escapeHtml(sku) + '</a>'
//       : ns.helpers.escapeHtml(sku);

//     var compatibilityButton = '';

//     if (part.interchangeabilities && part.madison_sku) {
//       compatibilityButton =
//         '<div class="spare-parts__compat-wrap">' +
//         '<button type="button" class="spare-parts__compat-toggle" data-compat-toggle="' + ns.helpers.escapeHtml(part.madison_sku) + '" aria-expanded="false">' +
//         'Show compatibility</button>' +
//         '<div class="spare-parts__compat" data-compat-target="' + ns.helpers.escapeHtml(part.madison_sku) + '" hidden></div>' +
//         '</div>';
//     }

//     return [
//       '<tr data-part-row="' + ns.helpers.escapeHtml(part.bom_index) + '">',
//       '<td><button type="button" class="spare-parts__index" data-index="' + ns.helpers.escapeHtml(part.bom_index) + '"></button></td>',
//       '<td>' + skuLabel + '</td>',
//       '<td data-full="true">',
//       ns.helpers.escapeHtml(part.part_name || ''),
//       compatibilityButton,
//       '</td>',
//       '<td data-full="true">' + stockMarkup(part) + '</td>',
//       '<td>' + orderMarkup(part) + '</td>',
//       '</tr>'
//     ].join('');
//   }

//   function renderHotspots(instance, data, imageEl, svgEl) {
//     var hotspots = data.hotspots || {};
//     var naturalWidth = imageEl.naturalWidth || imageEl.width || 1;
//     var naturalHeight = imageEl.naturalHeight || imageEl.height || 1;
//     var seen = {};
//     var svg = '';

//     Object.keys(hotspots).forEach(function (key) {
//       var hotspot = hotspots[key];
//       var x = Number(hotspot.x_coordinate || 0);
//       var y = Number(hotspot.y_coordinate || 0);
//       var width = Number(hotspot.hotspot_width || 12);
//       var itemNo = String(hotspot.item_no || '');
//       var uniqueKey = [itemNo, x, y].join(':');

//       if (!itemNo || seen[uniqueKey]) return;
//       seen[uniqueKey] = true;

//       var cx = ((x + width / 2) / naturalWidth) * 100;
//       var cy = ((y + width / 2) / naturalHeight) * 100;
//       var radius = (width / naturalWidth) * 100;

//       svg += '<circle class="spare-parts__hotspot" data-index="' + ns.helpers.escapeHtml(itemNo) + '" cx="' + cx + '%" cy="' + cy + '%" r="' + radius + '%"></circle>';
//     });

//     svgEl.setAttribute('viewBox', '0 0 ' + naturalWidth + ' ' + naturalHeight);
//     svgEl.innerHTML = svg;
//   }

//  function bindInteractions(instance) {
//   var container = detailContainer(instance);
//   if (!container) return;

//   if (instance._partsInteractionsBound) {
//     return;
//   }

//   instance._partsInteractionsBound = true;

//   function toggleIndex(index) {
//     container.querySelectorAll('[data-index]').forEach(function (element) {
//       if (element.getAttribute('data-index') !== index) return;
//       element.classList.toggle('is-active');
//     });
//   }

//   function closeOtherCompatibility(openButton) {
//     container.querySelectorAll('.spare-parts__compat-toggle[aria-expanded="true"]').forEach(function (button) {
//       if (button === openButton) return;

//       var sku = button.getAttribute('data-compat-toggle');
//       var target = container.querySelector('[data-compat-target="' + sku + '"]');
//       var row = button.closest('tr');

//       button.setAttribute('aria-expanded', 'false');
//       button.textContent = 'Show compatibility';

//       if (target) {
//         target.hidden = true;
//       }

//       if (row) {
//         row.classList.remove('is-expanded');
//       }
//     });
//   }

//   container.addEventListener('click', function (event) {
//     var indexButton = event.target.closest('.spare-parts__index');
//     var hotspot = event.target.closest('.spare-parts__hotspot');
//     var compatButton = event.target.closest('[data-compat-toggle]');

//     if (indexButton) {
//       toggleIndex(indexButton.getAttribute('data-index'));
//       return;
//     }

//     if (hotspot) {
//       toggleIndex(hotspot.getAttribute('data-index'));
//       return;
//     }

//     if (compatButton) {
//       var compatSku = compatButton.getAttribute('data-compat-toggle');
//       var target = container.querySelector('[data-compat-target="' + compatSku + '"]');
//       var row = compatButton.closest('tr');
//       if (!target) return;

//       var opening = target.hidden;
//       closeOtherCompatibility(compatButton);
//       target.hidden = !opening;
//       compatButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
//       compatButton.textContent = opening ? 'Hide compatibility' : 'Show compatibility';

//       if (row) {
//         row.classList.toggle('is-expanded', opening);
//       }

//       if (opening && !target.dataset.loaded && window.SpareParts.loadCompatibility) {
//         window.SpareParts.loadCompatibility(instance, compatSku, target);
//       }
//     }
//   });
// }

//   ns.loadParts = async function (instance, doc) {
//     renderLoading(instance);

//     try {
//       var payload = {
//         doc: doc.doc_no,
//         account: instance.config.account,
//         no_price: true
//       };

//      if (instance.config.brand) {
//   payload.brand = instance.config.brand;
// }

//       var data = await ns.helpers.fetchJson(instance.config.apiBase + '/parts', payload);

//       if (!data || data.status === '404') {
//         renderMessage(instance, 'No exploded-view parts were found for this document.');
//         return;
//       }

//       var parts = data.parts || {};
//       var rows = Object.keys(parts)
//         .map(function (key) {
//           return { id: key, part: parts[key] };
//         })
//         .sort(function (a, b) {
//           var aHasSku = a.part.madison_sku && a.part.url ? 1 : 0;
//           var bHasSku = b.part.madison_sku && b.part.url ? 1 : 0;
//           return bHasSku - aHasSku;
//         })
//         .map(function (entry) {
//           return rowMarkup(entry.id, entry.part);
//         })
//         .join('');

//       detailContainer(instance).innerHTML = [
//         '<div class="spare-parts__panel">',
//         '<div class="spare-parts__figure">',
//         '<img src="' + ns.helpers.escapeHtml(data.image_file_path || doc.image_file_path || '') + '" alt="Parts diagram" class="spare-parts__image">',
//         '<svg class="spare-parts__overlay"></svg>',
//         '</div>',
//         '<table class="spare-parts__table">',
//         '<thead><tr><th>No</th><th>Part No</th><th>Name</th><th>Availability</th><th>Order</th></tr></thead>',
//         '<tbody>',
//         rows,
//         '</tbody>',
//         '</table>',
//         '</div>'
//       ].join('');

//       var imageEl = detailContainer(instance).querySelector('.spare-parts__image');
//       var svgEl = detailContainer(instance).querySelector('.spare-parts__overlay');

//       if (imageEl.complete) {
//         renderHotspots(instance, data, imageEl, svgEl);
//       } else {
//         imageEl.addEventListener(
//           'load',
//           function () {
//             renderHotspots(instance, data, imageEl, svgEl);
//           },
//           { once: true }
//         );
//       }

//       bindInteractions(instance);
//     } catch (error) {
//       console.error('[Spares] parts fetch failed', error);
//       renderMessage(instance, 'The exploded-view diagram is temporarily unavailable.');
//     }
//   };
// })();



(function () {
  var ns = (window.SpareParts = window.SpareParts || {});
  ns.helpers = ns.helpers || {};

  function detailContainer(instance) {
    return instance.root.querySelector('.spare-parts__detail');
  }

  function renderLoading(instance) {
    detailContainer(instance).innerHTML = '<div class="spare-parts__loading"></div>';
  }

  function renderMessage(instance, message) {
    detailContainer(instance).innerHTML =
      '<div class="spare-parts__message">' +
      ns.helpers.escapeHtml(message) +
      '</div>';
  }

  // Public storefront lookup: no Shopify credentials or backend changes.
  var skuLookups = new Map();
  function lookupShopifySku(sku) {
    var key = String(sku || '').trim();
    if (!key) return Promise.resolve(null);
    if (skuLookups.has(key)) return skuLookups.get(key);
    var request = (async function () {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 8000);
      try {
        var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        var url = new URL(routeRoot + 'search', window.location.origin);
        url.searchParams.set('view', 'spare-parts-sku');
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', key);
        url.searchParams.set('options[prefix]', 'none');
        url.searchParams.set('options[unavailable_products]', 'show');
        var response = await fetch(url.toString(), { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('SKU lookup failed: ' + response.status);
        var data = await response.json();
        if (!Array.isArray(data.matches)) throw new Error('SKU search template is unavailable');
        var matches = data.matches.filter(function (match) {
          return String(match.sku || '').trim().toLowerCase() === key.toLowerCase();
        });
        // Do not guess when duplicate SKUs or incomplete search results exist.
        if (data.more_pages || matches.length !== 1) return null;
        var match = matches[0];
        var target = new URL(match.url, window.location.origin);
        if (target.origin !== window.location.origin || !target.pathname.includes('/products/')) return null;
        return { url: target.pathname + target.search, available: match.available === true };
      } finally { clearTimeout(timer); }
    })();
    skuLookups.set(key, request);
    request.catch(function () { skuLookups.delete(key); });
    return request;
  }

  async function linkShopifyProducts(instance, parts) {
    var container = detailContainer(instance);
    var table = container.querySelector('.spare-parts__table');
    var skus = Array.from(new Set(Object.keys(parts).map(function (id) {
      return String(parts[id].madison_sku || parts[id].global_sku_code || '').trim();
    }).filter(Boolean)));
    var next = 0;
    async function worker() {
      while (next < skus.length) {
        var sku = skus[next++];
        try {
          var match = await lookupShopifySku(sku);
          if (!match || container.querySelector('.spare-parts__table') !== table) continue;
          table.querySelectorAll('[data-part-sku]').forEach(function (row) {
            if (row.dataset.partSku !== sku) return;
            row.querySelector('[data-part-sku-cell]').innerHTML =
              '<a class="spare-parts__sku" href="' + ns.helpers.escapeHtml(match.url) + '">' + ns.helpers.escapeHtml(sku) + '</a>';
            row.querySelector('[data-part-order-cell]').innerHTML =
              '<a class="spare-parts__buy" href="' + ns.helpers.escapeHtml(match.url) + '">' +
              (match.available ? 'Buy' : 'Info') + '</a>';
          });
        } catch (error) {
          console.debug('[Spares] Shopify SKU lookup unavailable:', sku, error.message);
        }
      }
    }
    await Promise.all(Array.from({ length: Math.min(4, skus.length) }, worker));
  }

  function stockMarkup(part) {
    if (part.madison_sku && part.stock != null && part.stock !== '') {
      if (Number(part.stock) > 0) {
        return '<span class="spare-parts__stock spare-parts__stock--in">In stock</span>';
      }

      return '<span class="spare-parts__stock spare-parts__stock--out">Out of stock</span>';
    }

    return '<span class="spare-parts__stock spare-parts__stock--none">' +
      (part.obsolete ? 'Obsolete' : 'Not stocked') +
      '</span>';
  }

  function orderMarkup(part) {
    if (part.madison_sku && part.url) {
      var href = ns.helpers.productUrl(part.url);
      return '<a class="spare-parts__buy" href="' + ns.helpers.escapeHtml(href) + '">' +
        (Number(part.stock) > 0 ? 'Buy' : 'Info') +
        '</a>';
    }

    if (part.obsolete) {
      return '';
    }

    return '<a href="/pages/contact-us">Contact Us</a>';
  }

  function rowMarkup(partId, part) {
    var sku = part.madison_sku || part.global_sku_code || '';
    var skuLabel = part.madison_sku && part.url
      ? '<a class="spare-parts__sku" href="' + ns.helpers.escapeHtml(ns.helpers.productUrl(part.url)) + '">' + ns.helpers.escapeHtml(sku) + '</a>'
      : ns.helpers.escapeHtml(sku);

    var compatibilityButton = '';

    if (part.interchangeabilities && part.madison_sku) {
      compatibilityButton =
        '<div class="spare-parts__compat-wrap">' +
        '<button type="button" class="spare-parts__compat-toggle" data-compat-toggle="' + ns.helpers.escapeHtml(part.madison_sku) + '" aria-expanded="false">' +
        'Show compatibility</button>' +
        '<div class="spare-parts__compat" data-compat-target="' + ns.helpers.escapeHtml(part.madison_sku) + '" hidden></div>' +
        '</div>';
    }

    return [
      '<tr data-part-row="' + ns.helpers.escapeHtml(part.bom_index) + '" data-part-sku="' + ns.helpers.escapeHtml(sku) + '">',
      '<td><button type="button" class="spare-parts__index" data-index="' + ns.helpers.escapeHtml(part.bom_index) + '"></button></td>',
      '<td data-part-sku-cell>' + skuLabel + '</td>',
      '<td data-full="true">',
      ns.helpers.escapeHtml(part.part_name || ''),
      compatibilityButton,
      '</td>',
      '<td data-full="true">' + stockMarkup(part) + '</td>',
      '<td data-part-order-cell>' + orderMarkup(part) + '</td>',
      '</tr>'
    ].join('');
  }

  function renderHotspots(instance, data, imageEl, svgEl) {
    var hotspots = data.hotspots || {};
    var naturalWidth = imageEl.naturalWidth || imageEl.width || 1;
    var naturalHeight = imageEl.naturalHeight || imageEl.height || 1;
    var seen = {};
    var svg = '';

    Object.keys(hotspots).forEach(function (key) {
      var hotspot = hotspots[key];
      var x = Number(hotspot.x_coordinate || 0);
      var y = Number(hotspot.y_coordinate || 0);
      var width = Number(hotspot.hotspot_width || 12);
      var itemNo = String(hotspot.item_no || '');
      var uniqueKey = [itemNo, x, y].join(':');

      if (!itemNo || seen[uniqueKey]) return;
      seen[uniqueKey] = true;

      var cx = ((x + width / 2) / naturalWidth) * 100;
      var cy = ((y + width / 2) / naturalHeight) * 100;
      var radius = (width / naturalWidth) * 100;

      svg += '<circle class="spare-parts__hotspot" data-index="' + ns.helpers.escapeHtml(itemNo) + '" cx="' + cx + '%" cy="' + cy + '%" r="' + radius + '%"></circle>';
    });

    svgEl.setAttribute('viewBox', '0 0 ' + naturalWidth + ' ' + naturalHeight);
    svgEl.innerHTML = svg;
  }

 function bindInteractions(instance) {
  var container = detailContainer(instance);
  if (!container) return;

  if (instance._partsInteractionsBound) {
    return;
  }

  instance._partsInteractionsBound = true;

  function toggleIndex(index) {
    container.querySelectorAll('[data-index]').forEach(function (element) {
      if (element.getAttribute('data-index') !== index) return;
      element.classList.toggle('is-active');
    });
  }

  function closeOtherCompatibility(openButton) {
    container.querySelectorAll('.spare-parts__compat-toggle[aria-expanded="true"]').forEach(function (button) {
      if (button === openButton) return;

      var sku = button.getAttribute('data-compat-toggle');
      var target = container.querySelector('[data-compat-target="' + sku + '"]');
      var row = button.closest('tr');

      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'Show compatibility';

      if (target) {
        target.hidden = true;
      }

      if (row) {
        row.classList.remove('is-expanded');
      }
    });
  }

  container.addEventListener('click', function (event) {
    var indexButton = event.target.closest('.spare-parts__index');
    var hotspot = event.target.closest('.spare-parts__hotspot');
    var compatButton = event.target.closest('[data-compat-toggle]');

    if (indexButton) {
      toggleIndex(indexButton.getAttribute('data-index'));
      return;
    }

    if (hotspot) {
      toggleIndex(hotspot.getAttribute('data-index'));
      return;
    }

    if (compatButton) {
      var compatSku = compatButton.getAttribute('data-compat-toggle');
      var target = container.querySelector('[data-compat-target="' + compatSku + '"]');
      var row = compatButton.closest('tr');
      if (!target) return;

      var opening = target.hidden;
      closeOtherCompatibility(compatButton);
      target.hidden = !opening;
      compatButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
      compatButton.textContent = opening ? 'Hide compatibility' : 'Show compatibility';

      if (row) {
        row.classList.toggle('is-expanded', opening);
      }

      if (opening && !target.dataset.loaded && window.SpareParts.loadCompatibility) {
        window.SpareParts.loadCompatibility(instance, compatSku, target);
      }
    }
  });
}

  ns.loadParts = async function (instance, doc) {
    renderLoading(instance);

    try {
      var payload = {
        doc: doc.doc_no,
        account: instance.config.account,
        no_price: true,
        ofset: 12
      };

     if (instance.config.brand) {
  payload.brand = instance.config.brand;
}

      var data = await ns.helpers.fetchJson(instance.config.apiBase + '/parts', payload);

      if (!data || data.status === '404') {
        renderMessage(instance, 'No exploded-view parts were found for this document.');
        return;
      }

      var parts = data.parts || {};
      var rows = Object.keys(parts)
        .map(function (key) {
          return { id: key, part: parts[key] };
        })
        .sort(function (a, b) {
          var aHasSku = a.part.madison_sku && a.part.url ? 1 : 0;
          var bHasSku = b.part.madison_sku && b.part.url ? 1 : 0;
          return bHasSku - aHasSku;
        })
        .map(function (entry) {
          return rowMarkup(entry.id, entry.part);
        })
        .join('');

      detailContainer(instance).innerHTML = [
        '<div class="spare-parts__panel">',
        '<div class="spare-parts__figure">',
        '<img src="' + ns.helpers.escapeHtml(data.image_file_path || doc.image_file_path || '') + '" alt="Parts diagram" class="spare-parts__image">',
        '<svg class="spare-parts__overlay"></svg>',
        '</div>',
        '<table class="spare-parts__table">',
        '<thead><tr><th>No</th><th>Part No</th><th>Name</th><th>Availability</th><th>Order</th></tr></thead>',
        '<tbody>',
        rows,
        '</tbody>',
        '</table>',
        '</div>'
      ].join('');

      var imageEl = detailContainer(instance).querySelector('.spare-parts__image');
      var svgEl = detailContainer(instance).querySelector('.spare-parts__overlay');

      if (imageEl.complete) {
        renderHotspots(instance, data, imageEl, svgEl);
      } else {
        imageEl.addEventListener(
          'load',
          function () {
            renderHotspots(instance, data, imageEl, svgEl);
          },
          { once: true }
        );
      }

      bindInteractions(instance);
      linkShopifyProducts(instance, parts);
    } catch (error) {
      console.error('[Spares] parts fetch failed', error);
      renderMessage(instance, 'The exploded-view diagram is temporarily unavailable.');
    }
  };
})();
